'use client';

import clsx from 'clsx';
import { CMSLink } from '../CMSLink';
import { useLocalityService } from '@/providers/Locality';
import { GeneralInformation } from '@/payload-types';

type linkFromGeneralInformation = NonNullable<
  NonNullable<GeneralInformation['socialNetworks']>[number]['social']
>[number];

export default function LocalityContactButton({
  links,
  className,
}: {
  links: linkFromGeneralInformation[];
  className: string;
}) {
  const localityService = useLocalityService();

  return (
    localityService && (
      <div className={clsx('flex items-center gap-x-6', className)}>
        {links.map((link) => (
          <CMSLink
            key={link.id}
            {...link.link}
            className="rounded-md bg-[#0079AD] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#005E87] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          />
        ))}
        {/* <Link
                href={callToAction.href}
                className="rounded-md bg-[#0079AD] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#005E87] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
                {callToAction.label}
            </Link> */}
      </div>
    )
  );
}
